<div class="order-info-card dropdown-content-root">
	<div class="order-header">
		<div class="inner">
			<div class="left">
				<div
					class="title"
					[tuiSkeleton]="isLoadingAssetInfo()"
				>
					<app-company-logo
						[logoSrc]="assetsInfo()?.icon"
						[symbol]="assetsInfo()?.ticker"
						logoWidth="24px"
						logoHeight="24px"
						[logoAlt]="assetsInfo()?.ticker"
					/>
					<p class="name">{{ assetsInfo()?.ticker }}</p>
				</div>
			</div>

			<div class="right">
				<span class="value">{{ order?.created_at | date: 'dd.MM.yyyy / HH:mm:ss' }}</span>
				<tui-icon
					class="icon"
					icon="@tui.x"
					(click)="onCloseDropdown()"
				/>
			</div>
		</div>
	</div>

	<div class="order-body">
		<app-info-options-order-header [order]="order" />
		<app-info-options-order-body [order]="order" />
	</div>
</div>
